import React, { useState } from 'react';
import { Col, Row } from 'antd';
import PropTypes from 'prop-types';
import { ButtonLoadMoreItems } from './ButtonLoadMoreItems';
import { useListNodes } from './hooks/useListNodes';
import { ModalEditNode } from './ModalEditNode';
import { CustomListItems } from './CustomListItems';
import { Button } from '../../../../components/buttons/buttons';
import { useDictionaryTranslation } from '../../../../hooks/useDictionaryTranslation';
import { useImportCustomList } from '../customLists/hooks/useImportCustomList';
import ModalImportItem from '../../../../components/importsModal/ModalImportItems';

const ListNodes = ({ customListId }) => {
  const { translate: t } = useDictionaryTranslation();
  const [isOpenNodeListModal, setOpenNodeListModal] = useState(false);
  const [isOpenImportModal, setOpenImportModal] = useState(false);
  const listNodesData = useListNodes();
  const { importList } = useImportCustomList();

  const openNodeListModal = () => {
    setOpenNodeListModal(true);
  };

  const closeNodesModal = () => {
    setOpenNodeListModal(false);
  };

  const openImportModal = () => {
    setOpenImportModal(true);
  };

  const closeImportModal = ({ successImport = false } = {}) => {
    if (successImport) {
      listNodesData.getListNodes();
    }
    setOpenImportModal(false);
  };

  const onHandleImportList = (data) => {
    importList(customListId, data.file, data.idAcount);
  };

  const saveNode = (nodeId, nodeValues) => {
    if (nodeId == null) {
      listNodesData.addListNode({ path: [], nodeData: nodeValues });
    } else {
      listNodesData.updateListNode({ path: [], nodeId, nodeData: nodeValues });
    }
  };

  return (
    <>
      <Row justify="end" gutter={10}>
        <Col>
          <Button type="secondary" onClick={openImportModal}>
            {t('import')}
          </Button>
        </Col>
        <Col>
          <Button type="primary" onClick={openNodeListModal}>
            {t('addListItem')}
          </Button>
        </Col>
      </Row>
      <CustomListItems path={[]} nodes={listNodesData.nodes} />
      <ButtonLoadMoreItems page={listNodesData.page} pageSize={listNodesData.pageSize} total={listNodesData.total} />

      {isOpenNodeListModal ? (
        <ModalEditNode show={isOpenNodeListModal} handleClose={closeNodesModal} saveNode={saveNode} />
      ) : null}
      <ModalImportItem handleClose={closeImportModal} show={isOpenImportModal} importList={onHandleImportList} />
    </>
  );
};

export default ListNodes;

ListNodes.propTypes = {
  customListId: PropTypes.string,
};
